<template>
    <div class="account-investigator-card">
      <div class="card-top">
        <div class="card-title">
          <span class="title">{{ accountIdentificationHeader }}</span>
        </div>
        <div class="card-text">
          {{ question.account }}
        </div>
        <div>
          <img v-if="sourceTypeToLogoFile" class="logo" :src="require(`@/assets/bank-logos-30/${sourceTypeToLogoFile}`)">
        </div>
      </div>
      <div class="buttons">
        <riseup-button class="button-container"
                       :action="() => setAccountStatusClicked(accountStatuses.include)"
                       :title="'תוסיף אותו לתזרים'"
                       :variant="'primary'"/>
        <riseup-button class="button-container"
                       :action="() => setAccountStatusClicked(accountStatuses.exclude)"
                       :title="'אל תוסיף אותו לתזרים'"
                       :variant="'secondary'"/>
      </div>
      <div class="card-subtitle">
        <span>משהו נראה לא נכון?</span>
        <span class="link" v-on:click="setAccountStatusClicked(accountStatuses.notApproved)">דווחו כאן על תקלה</span>
      </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../../../Segment';
import sourceToLogo from '../../../../../../../utils/sourcesToLogo';

export default {
  name: 'AccountInvestigationCard',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('accountInvestigationQuestions', ['noUnansweredAccountQuestions']),
    accountStatuses() {
      return {
        include: 'include',
        exclude: 'exclude',
        notApproved: 'notApproved',
      };
    },
    account() {
      return this.question.account;
    },
    accountIdentificationHeader() {
      return 'זיהיתי חשבון בנק:';
    },
    sourceTypeToLogoFile() {
      return sourceToLogo[this.question.source];
    },
  },
  methods: {
    ...mapActions('accountInvestigationQuestions', [
      'setAccountStatus',
    ]),
    async setAccountStatusClicked(accountStatus) {
      Segment.trackUserInteraction('AccountInvestigationClicked', {
        question: {
          account: this.question.account,
          sourceType: this.question.sourceType,
          source: this.question.source,
        },
        answer: accountStatus,
      });
      await this.setAccountStatus({
        accountStatus,
        accountDetails: this.question,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../scss/mixins';

  .account-investigator-card {
    @include card;
    padding: 16px 24px;

    .card-top {
      margin-bottom: 16px;

      .card-title {
        line-height: 1;
        margin-bottom: 12px;

        .title {
          font-size: 20px;
        }
      }

      .card-text {
        font-family: SimplerProBold;
        line-height: 35px;
        text-align: right;
        font-size: 24px;
        color: $riseup_black;
        margin-bottom: 20px;
      }

      .logo {
        text-align: right;
        height: 40px;
        margin-bottom: 5px;
      }
    }

    .buttons {
      .button-container {
        margin-bottom: 16px;
      }
    }

    .card-question-footer {
      width: 100%;
      padding: 40px 0;
      text-align: center;
      color: white;
      background: $riseup_green;

      .footer-title {
        font-family: SimplerProBold;
        line-height: 20px;
        font-size: 20px;
      }

      .footer-subtitle {
        font-size: 16px;
        line-height: 16px;
      }
    }
    }
    .card.identified {
      .card-title {
        position: relative;
        left: 4px;
      }
    }

    .card-subtitle {
      margin-top: 8px;
      font-size: 14px;
      color: $riseup_gray_2;
      text-align: center;
      line-height: 14px;
      font-family: SimplerProBold;

      .link {
        color: $riseup_light_blue;
        font-family: SimplerProBold;
        text-decoration: underline;
        cursor: pointer;
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/investigations/account-investigation-in-app/AccountInvestigationCard.vue